import React from 'react';
import PropTypes from 'prop-types';

import Tag from 'components/Tag';
import Slider from 'components/sliders/Slider';

const Tabs = React.memo(({ tabs, activeTab, onClick }) => (
	<Slider withNavigation theme="lightTags" navigationIcon="chevronSmall">
		{tabs.map((tab) => (
			<Tag
				key={tab.title}
				title={tab.title}
				onClick={() => onClick?.(tab)}
				theme="transparent"
				size="narrow"
				bold={false}
				active={activeTab?.title === tab?.title}
			/>
		))}
	</Slider>
));

Tabs.propTypes = {
	tabs: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string.isRequired
		})
	).isRequired,
	activeTab: PropTypes.shape({
		title: PropTypes.string.isRequired
	}),
	onClick: PropTypes.func
};

export default Tabs;
